import React from 'react';
import SVG from 'react-inlinesvg';

import IconSearchSVG from '../../../../../assets/icons/Search.svg';
import { ContainerInputSearch } from './styles';

function InputSearch() {
  return (
    <ContainerInputSearch>
      <SVG className="svg" src={IconSearchSVG} width={24} />
      <input type="search" id="site-search" placeholder="Buscar" />
    </ContainerInputSearch>
  );
}

export default InputSearch;
